import React from 'react';

export default class ConnectCardEditor extends React.Component {
  render() {
    return (
      <div className="tile">
        <h2>Connect Cards</h2>
      </div>
    );
  }
}
